import { Text, View } from '@react-pdf/renderer';
import { createColumnHelper } from '@tanstack/react-table';
import { upperFirst } from 'lodash-es';

import { VehicleInspectionReportDetailsRead } from 'src/common/external/bambi-api/bambiApi';
import { PDFTable } from 'src/common/pdf/PDFTable/PDFTable';

export type VehicleReportItem =
  VehicleInspectionReportDetailsRead['report_json'][0];

const columnHelper = createColumnHelper<VehicleReportItem>();

const columns = [
  columnHelper.display({
    id: 'title',
    header: () => <Text>ITEMS</Text>,
    cell({ row }) {
      return <Text>{row.original.title}</Text>;
    },
  }),
  columnHelper.display({
    id: 'value',
    header: () => (
      <View style={{ alignItems: 'flex-end' }}>
        <Text>DEFECTIVE</Text>
      </View>
    ),
    cell({ row }) {
      return (
        <View style={{ alignItems: 'flex-end' }}>
          <Text>{upperFirst(row.original.value)}</Text>
        </View>
      );
    },
  }),
];

interface VehicleInspectionReportItemTableProps {
  data: VehicleReportItem[];
}

export function VehicleInspectionReportItemTable({
  data,
}: VehicleInspectionReportItemTableProps) {
  return <PDFTable columns={columns} data={data} />;
}
